export const environment = {
  production: true,
  sentryEnv: 'production',
  identityServer: 'https://auth.atmosphericg2.com',
  clientid: 'ag2-weathermaker',
  apiUrl: 'https://api.ag2weathermaker.com/',
  features: {
    weightAndEditByRegion: true,
  },
};
